<template>
  <div class="workOrderDetails">
    <template v-if="active == 0">
      <div class="workOrderDetails_title">工单详情</div>
      <div class="workOrderDetails_box">
        <div class="workOrderDetails_box_title">{{ detailsInfo.title }}</div>
        <div class="workOrderDetails_box_content">
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="负责人："
            :value="detailsInfo.userName" />
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="计划开始时间："
            :value="detailsInfo.planStartTime" />
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="计划结束时间："
            :value="detailsInfo.platEndTime" />
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="内容" :title-width="'50px'" >
          <div v-html="detailsInfo.content" class="htmlBox" @click="imageEnlargement"></div>
          </van-cell>
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" v-if="detailsInfo.fileList.length != 0"
            title="文件：" value-class="cell_value">
            <template #default>
              <div style="display: flex;align-items: center;flex-wrap: wrap;">
                <span style="display: inline-block;margin-left: 10px;cursor: pointer;color: #409EFF;" @click="go(item)"
                  v-for="(item, index) in detailsInfo.fileList" :key="index">附件 {{ index + 1 }}</span>
              </div>
            </template>
          </van-cell>
        </div>
      </div>
      <div class="workOrderDetails_box">
        <div class="workOrderDetails_box_title">状态</div>
        <div class="workOrderDetails_box_content">
          <!-- <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="审核人："
          :value="detailsInfo.reviewer" /> -->
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="状态：">
            <template #default>
              <span class="workOrder_top_content_box_top_span">
                <el-tag v-if="detailsInfo.status == 1" size="small">进行中</el-tag>
                <el-tag v-if="detailsInfo.status == 2" size="small" type="success">已完成</el-tag>
                <el-tag v-if="detailsInfo.status == 3" size="small" type="info">已交付</el-tag>
                <el-tag v-if="detailsInfo.status == 4" size="small" type="danger">延期</el-tag>
                <el-tag v-if="detailsInfo.status == 5" size="small" type="warning">待评审</el-tag>
                <el-tag v-if="detailsInfo.status == 6" size="small" type="info">待开始</el-tag>
              </span>
            </template>
          </van-cell>
          <div class="workOrderDetails_box_content_content">
            <div class="workOrderDetails_box_content_content_box" v-if="detailsInfo.status == 3">
              <span class="workOrderDetails_box_content_content_box_span">驳回原因：</span>
              <span class="workOrderDetails_box_content_content_box_span2">{{ detailsInfo.rejectMessage }}</span>
            </div>
          </div>
          <div class="workOrderDetails_btnBox" v-if="notAuthorized == 1">
        <van-button type="default" round size="small" @click="workAddOrder(detailsInfo)">新增子工单</van-button>
        <van-button v-if="detailsInfo.status == 1" round type="info" size="small" @click="handlePostpone(detailsInfo)"
          color="#FF8165">延期</van-button>
        <van-button v-if="detailsInfo.status == 6" round type="info" size="small"
          @click="upStatusFun(detailsInfo)">开始</van-button>
        <van-button v-if="detailsInfo.status == 3 && isExamine == 1" type="info" size="small"
          @click="handleReview(detailsInfo)">评审</van-button>
        <van-button type="info" v-if="detailsInfo.status != 3" size="small"
          @click="handleUpdate(detailsInfo)">修改</van-button>
      </div>
        </div>
      </div>
      <div class="workOrderDetails_title">项目简介</div>
      <div class="workOrderDetails_box">
        <div class="workOrderDetails_box_title">{{ demandInfo.title }}</div>
        <div class="workOrderDetails_box_content">
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="提出人："
            :value="demandInfo.userName" />
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="手机号"
            :value="demandInfo.phone" />
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="工单类型："
            :value="demandInfo.type == 1 ? '内部' : '外部'" />
          <van-cell :border="false" v-if="demandInfo.incomeType != 3" title-class="workOrder_top_content_box_content_cell_title"
            value-class="cell_value" title="奖金："
            :value="demandInfo.money ? demandInfo.money : demandInfo.incomeRemark" />
          <van-cell :border="false" v-else title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value"
            title="奖金：" value="无" />
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" title="紧急程度：" value-class="cell_value">
            <template #default>
              <div class="time colorBoxBig">
                <span class="colorBox" v-if="demandInfo.level == 1" style="background: #F56C6C;"></span>
                <span class="colorBox" v-if="demandInfo.level == 2" style="background: #E6A23C;"></span>
                <span class="colorBox" v-if="demandInfo.level == 3" style="background: #409EFF;"></span>
              </div>
            </template>
          </van-cell>
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="内容" :title-width="'50px'">
          <template #default>
            <div v-html="demandInfo.content" class="htmlBox"  @click="imageEnlargement"></div>
          </template>
          </van-cell>
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" v-if="demandInfo.fileList.length != 0"
            title="文件：" value-class="cell_value">
            <template #default>
              <div style="display: flex;align-items: center;flex-wrap: wrap;">
                <span style="display: inline-block;margin-left: 10px;cursor: pointer;color: #409EFF;" @click="go(item)"
                  v-for="(item, index) in demandInfo.fileList" :key="index">附件 {{ index + 1 }}</span>
              </div>
            </template>
          </van-cell>
        </div>
      </div>
      <div class="workOrderDetails_box">
        <div class="workOrderDetails_box_title">状态</div>
        <div class="workOrderDetails_box_content">
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="审核人："
            :value="demandInfo.reviewer" />
          <van-cell :border="false" title-class="workOrder_top_content_box_content_cell_title" value-class="cell_value" title="状态：">
            <template #default>
              <span class="workOrder_top_content_box_top_span">
                <el-tag v-if="demandInfo.status == 4" size="small">已转为工单</el-tag>
                <el-tag v-if="demandInfo.status == 2" size="small" type="success">通过</el-tag>
                <el-tag v-if="demandInfo.status == 3" size="small" type="danger">驳回</el-tag>
                <el-tag v-if="demandInfo.status == 1" size="small" type="warning">待评审</el-tag>
              </span>
            </template>
          </van-cell>
          <div class="workOrderDetails_box_content_content">
            <div class="workOrderDetails_box_content_content_box" v-if="demandInfo.status == 3">
              <span class="workOrderDetails_box_content_content_box_span">驳回原因：</span>
              <span class="workOrderDetails_box_content_content_box_span2">{{ demandInfo.rejectMessage }}</span>
            </div>
            <div class="workOrderDetails_box_content_content_box" v-if="demandInfo.status == 2">
              <span class="workOrderDetails_box_content_content_box_span3">排期时间：</span>
              <span class="workOrderDetails_box_content_content_box_span2">{{ demandInfo.startTime }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="active == 1">
      <workTask :status="status" :orderId="detailsInfo.id" />
    </template>
    <div style="height: 100px;"></div>
    <div class="btnBox">
      <van-tabbar v-model="active" @change="onChange">
        <van-tabbar-item icon="bookmark">详情</van-tabbar-item>
        <van-tabbar-item icon="notes">子工单</van-tabbar-item>
      </van-tabbar>
      <div>

      </div>
    </div>
    <workOrderPop ref="workOrderPop" @ok="getDetalis()" />
  </div>
</template>

<script>
import { getOrder, getDemand, updateOrder } from '@/api/workOrder'
import workTask from '@/views/signIn/workTask'
import Cookies from 'js-cookie'
import workOrderPop from '@/views/signIn/workOrderPop'
import { Dialog } from 'vant';
export default {
  name: "workOrder",
  components: { workTask, workOrderPop },
  data() {
    return {
      detailsInfo: {
        fileList: []
      },
      active: 0,
      status: '',
      demandInfo: {
        fileList: []
      },
      form: {},
      notAuthorized: 0
    };
  },
  mounted() {
    // console.log(this.$route.params)companyId,userId
    this.getDetalis()
    this.notAuthorized = Cookies.get('notAuthorized')
    this.isExamine =  Cookies.get("isExamine")
  },
  methods: {
         // 富文本图片内容 点击放大
         imageEnlargement(e) {
      if (e.target.nodeName === "IMG") {
        ImagePreview({
          images: [e.target.src], // 传递的是图片集数组
          startPosition: 0, // 图片索引位置
          closeable: true, // 是否显示关了按钮
          showIndicators: true, // 是否显示轮播指示器
          loop: false, // 不设置为false,首图和尾部图不能正常加载
        });
      }
    },
    getDetalis() {
      this.loading = true;
      getOrder(this.$route.params.id).then(response => {
        let rows = response.data;
        if (rows.wordFile) {
          rows.fileList = rows.wordFile.split(',')
        } else {
          rows.fileList = []
        }
        this.detailsInfo = rows
        this.status = rows.status
        console.log(this.status)
        this.getDetalisFun(rows.demandId)
      });
    },
    getDetalisFun(id) {
      getDemand(id).then(response => {
        let rows = response.data;
        if (rows.file) {
          rows.fileList = rows.file.split(',')
        } else {
          rows.fileList = []
        }
        this.demandInfo = rows
      });
    },
    workAddOrder(item) {
      var path = "/workAddOrder/" + Cookies.get("companyId") + '/' + Cookies.get("userId") + '/' + Cookies.get("phone") + '/' + item.id
      this.gotoUrl(path)
      // workOrderDetails
    },
    go(url) {
      if (window.__wxjs_environment === 'miniprogram') {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: '../public/downLoading?url=' + url,
        })
        // }, 100);
      } else {
        window.open(url)
        // alert('请在微信小程序中打开')
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        // this.$router.push(path);
      }
    },
    //跳转到公共页面
    gotoUrl(path) {
      console.log(11111111111111111);
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../public/goto?path=' + path,
        })
      } else {
        this.$router.push(path)
      }
    },
    onChange(e) {
      console.log(e)
    },
    handleUpdate(row) {
      this.form = row
      this.$refs.workOrderPop.showForm(this.form, '修改工单基本信息')
    },
    handlePostpone(row) {
      this.form = row
      this.$refs.workOrderPop.showForm(this.form, '填写延期原因')
    },
    upStatusFun(row) {
      this.form = row
      const that = this
      Dialog.confirm({
        title: '标题',
        message: '是否确认开始',
      })
        .then(() => {
          that.form.status = 1
          updateOrder(this.form).then(response => {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.getDetalis();
          });
        })
        .catch(() => {
        });
    },
    /** 评审按钮操作 */
    handleReview(row) {
      Dialog.confirm({
        title: '标题',
        message: '是否确认工单已评审？',
      })
        .then(() => {
          row.status = 2
          updateOrder(row).then(response => {
            this.$message({
              message: '评审成功',
              type: 'success'
            });
            this.getDetalis()
          });
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style scoped>
.workOrderDetails {
  background-color: #F7F7F7;
}

.workOrderDetails_title {
  font-size: 19px;
  font-weight: 700;
  color: #1E1E1E;
  background-color: #fff;
  padding: 20px 20px 0;
}

.workOrderDetails_box {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 15px;
}

.workOrderDetails_box_title {
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  padding-left: 10px;
  position: relative;
  /* border-left: 4px solid #3B87F7; */
}

.workOrderDetails_box_title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 20px;
  background-color: #3B87F7;
  position: absolute;
  left: 0;
  bottom: 1px;
}

.workOrderDetails_box_content {}

.colorBoxBig {
  align-items: center;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #999999;
  display: flex;
  align-items: flex-start;
}

.colorBox {
  display: inline-block;
  width: 25px;
  height: 13px;
  border-radius: 3px;
}

.colorBoxBig {
  align-items: center;
}

.cell_value {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  color: #333;
  font-weight: 700;
}

.workOrder_top_content_box_content_cell_title {
  color: #666666;
}

.workOrderDetails_box_content_content {}

.workOrderDetails_box_content_content_box {
  background-color: #F2F1F6;
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
}

.workOrderDetails_box_content_content_box_span {
  color: #FF8165;
}

.workOrderDetails_box_content_content_box_span3 {
  color: #97CC49;
}

.workOrderDetails_box_content_content_box_span2 {
  color: #666666;
  font-size: 15px;
  display: inline-block;
  margin-top: 10px;
}

.workOrderDetails_btnBox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 0px 0px;
  /* background-color: #fff; */
}
</style>
<style>
.workOrderDetails .van-cell {
  padding: 10px 0 0;
}

.workOrderDetails_btnBox .van-button {
  margin-left: 20px;
  min-width: 70px;
}
</style>